export const SWIPER_DATA_HEADER = [ 
    {
        img: 'assets/images/Encabezado_Servicios1.jpg',
        src: 'assets/video/1.mp4',
        title: 'HIDRÁULICA',
        data: 'Desarrollo de aplicaciones especiales en oleohidráulica y electro hidráulica. Taller altamente equipado con componentes oleohidráulicos'
    },
    {
        img: 'assets/images/Encabezado_Servicios2.jpg',
        src: 'assets/video/2.mp4',
        title: 'SERVICIO 2',
        data: 'Desarrollo de aplicaciones especiales en oleohidráulica y electro hidráulica. Taller altamente equipado con componentes oleohidráulicos'
    },
    {
        img: 'assets/images/Encabezado_Servicios3.jpg',
        title: 'SERVICIO 3',
        data: 'Desarrollo de aplicaciones especiales en oleohidráulica y electro hidráulica. Taller altamente equipado con componentes oleohidráulicos'
    },
];